import Image from 'next/image';
import { ReactNode } from 'react';

import { Text, Colors, staticCdnHost } from '@rockalingua/ui';

import {
  Background,
  Container,
  Content,
  ImageContainer,
} from './FooterCTA.styled';

type FooterCTAProps = {
  title: string;
  subtitle: string;
  button: ReactNode;
};

export default function FooterCTA({ title, subtitle, button }: FooterCTAProps) {
  return (
    <Background>
      <Container>
        <Content>
          <Text variant="grey-56-bold" color={Colors.BLUE} as="h2">
            {title}
          </Text>
          <Text variant="title-mid-grey-32" color={Colors.NEUTRAL_VARIANTS[90]}>
            {subtitle}
          </Text>
          {button}
        </Content>
        <ImageContainer>
          <Image
            src={`${staticCdnHost}/img/landings/teacher-ok-hand.svg`}
            alt="Teacher making an okay hand gesture"
            width={520}
            height={360}
          />
        </ImageContainer>
      </Container>
    </Background>
  );
}
